import axios from "axios";
import { API_END_POINT } from "../../constants/api";
import { getCompanyId } from "../../helper/utils/companyId";

import { returnErrors, clearErrors } from "./errorAction";
export const ADD_YARN_RETURN = "ADD_YARN_RETURN";

export const YARN_RETURN_EDIT = "YARN_RETURN_EDIT";
export const YARN_RETURN_EDIT_SUCCESS = "YARN_RETURN_EDIT_SUCCESS";
export const YARN_RETURN_EDIT_FAIL = "YARN_RETURN_EDIT_FAIL";

export const YARN_RETURN_DELETE = "YARN_RETURN_DELETE";
export const YARN_RETURN_DELETE_SUCCESS = "YARN_RETURN_DELETE_SUCCESS";
export const YARN_RETURN_DELETE_FAIL = "YARN_RETURN_DELETE_FAIL";

export const YARN_RECEIVED_EDIT = "YARN_RECEIVED_EDIT";
export const YARN_RECEIVED_EDIT_SUCCESS = "YARN_RECEIVED_EDIT_SUCCESS";
export const YARN_RECEIVED_EDIT_FAIL = "YARN_RECEIVED_EDIT_FAIL";

export const YARN_RECEIVED_DELETE = "YARN_RECEIVED_DELETE";
export const YARN_RECEIVED_DELETE_SUCCESS = "YARN_RECEIVED_DELETE_SUCCESS";
export const YARN_RECEIVED_DELETE_FAIL = "YARN_RECEIVED_DELETE_FAIL";

export const ADD_YAARN_RECEIVED = "ADD_YAARN_RECEIVED";
export const GET_YARN_HISTORY = "GET_YARN_HISTORY";
export const ADD_YARN_RETURN_FAIL = "ADD_YARN_RETURN_FAIL";
export const ADD_YAARN_RECEIVED_FAIL = "ADD_YAARN_RECEIVED_FAIL";

export const GET_YARN_RETURN_HISTORY = "GET_YARN_RETURN_HISTORY";

export function yarnReturnAction(yarnReturn, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const values = {
      ...yarnReturn,
      date: yarnReturn.date.format("YYYY-MM-DD"),
    };
    const body = JSON.stringify(values);

    axios
      .post(
        `${API_END_POINT}/api/company/contract/yarn/returned/register`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: ADD_YARN_RETURN,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn return add Successfully",
            201,
            "ADD_YARN_RETURN_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_YARN_RETURN_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editReturn(yarnReturnEdit, yarn_return_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      },
    };
    const values = yarnReturnEdit.date
      ? {
          ...yarnReturnEdit,
          date: yarnReturnEdit.date.format("YYYY-MM-DD"),
        }
      : yarnReturnEdit;
    console.log(yarnReturnEdit);

    const body = JSON.stringify(values);
    const url = `${API_END_POINT}/api/contract/yarn/return/update/${yarn_return_id}`;
    console.log(body, "body");
    axios
      .put(url, body, config)
      .then((res) =>
        dispatch({
          type: YARN_RETURN_EDIT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn return Edit Successfully",
            201,
            "YARN_RETURN_EDIT_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "YARN_RETURN_EDIT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function deleteYarnReturn(yarn_return_id, token) {
  const company_id = getCompanyId();
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .delete(
        `${API_END_POINT}/api/company/contract/yarn/returned/delete/${yarn_return_id.id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: YARN_RETURN_DELETE,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn Delete Successfully",
            201,
            "YARN_RETURN_DELETE_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "YARN_RETURN_DELETE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function yarnReceivedAction(yarnReceived, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const values = {
      ...yarnReceived,
      date: yarnReceived.date.format("YYYY-MM-DD"),
    };
    const body = JSON.stringify(values);

    axios
      .post(
        `${API_END_POINT}/api/company/contract/yarn/received/register`,
        body,
        config
      )
      .then(
        (res) => console.log("response from ", res)
        // dispatch({
        //   type: ADD_YAARN_RECEIVED,
        //   payload: res.data,
        // })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn received add Successfully",
            201,
            "ADD_YARN_RECIEVED_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_YARN_RECIEVED_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editReceived(yarnReceivedEdit, yarn_received_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const values = yarnReceivedEdit.date
      ? {
          ...yarnReceivedEdit,
          date: yarnReceivedEdit.date.format("YYYY-MM-DD"),
        }
      : yarnReceivedEdit;
    console.log(yarnReceivedEdit);
    console.log(yarnReceivedEdit);

    const body = JSON.stringify(values);
    const url = `${API_END_POINT}/api/contract/yarn/received/update/${yarn_received_id}`;
    console.log(body, "body");
    axios
      .put(url, body, config)
      .then((res) =>
        dispatch({
          type: YARN_RECEIVED_EDIT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn received Edit Successfully",
            201,
            "YARN_RECEIVED_EDIT_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "YARN_RECEIVED_EDIT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function deleteYarnReceived(yarn_received_id, token) {
  console.log(yarn_received_id.id);
  const company_id = getCompanyId();
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .delete(
        `${API_END_POINT}/api/company/contract/yarn/received/delete/${yarn_received_id.id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: YARN_RECEIVED_DELETE,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "yarn received Delete Successfully",
            201,
            "YARN_RECEIVED_DELETE_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "YARN_RECEIVED_DELETE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function getYarn(contract_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/api/company/contract/yarn/received/get/${contract_id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_YARN_HISTORY,
          payload: res.data,
        })
      )
      .catch((err) => console.log(err));
  };
}

export function getReturnYarn(contract_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/api/company/contract/yarn/returned/get/${contract_id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_YARN_RETURN_HISTORY,
          payload: res.data,
        })
      )
      .catch((err) => console.log(err));
  };
}
